var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconContactUsDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.264 3C8.494 3.008 3.008 8.494 3 15.264V24.9a2.628 2.628 0 0 0 2.628 2.628h3.504a.876.876 0 0 0 .876-.876v-8.76a.876.876 0 0 0-.876-.876H5.628c-.3.003-.596.058-.876.162v-1.914c0-5.806 4.706-10.512 10.512-10.512s10.512 4.706 10.512 10.512v1.914a2.599 2.599 0 0 0-.876-.162h-3.504a.876.876 0 0 0-.876.876v8.76c0 .484.392.876.876.876H24.9a2.628 2.628 0 0 0 2.628-2.628v-9.636C27.52 8.494 22.034 3.008 15.264 3z",
    fill: "#4A606A",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconContactUsDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-contact-us-default.c1f4987bb6bc4e65a75f6e523ba7bcb8.svg";